// extracted by mini-css-extract-plugin
export var select = "_qg-0";